module.exports = __webpack_public_path__ + "static/media/login-screen-image.5a633c2e.png";